// app-user · business page (Design Part 1, row 4). Spread into en.ts / bn.ts. The handoff
// chrome (services, team, call, paused…) is already in app-strings.ts as
// `app.business.*`; the keys here replace its demo-specific lines (doctor, chamber,
// named people) with copy that fits every vertical.
export const appEnBusiness = {
  'app.business.back': 'Back',
  'app.business.shareA11y': 'Share this business',
  'app.business.saveA11y': 'Save this business',
  'app.business.unsaveA11y': 'Remove from saved',
  'app.business.galleryA11y': 'Photos of {name}',
  'app.business.saved': 'Saved',
  'app.business.unsaved': 'Removed from saved',
  'app.business.saveError': 'Could not update saved places. Try again.',
  'app.business.offlineAction': 'You are offline. Connect to do this.',
  'app.business.notFoundTitle': 'We could not find this business',
  'app.business.notFoundBody': 'The link may be old, or the listing is no longer available.',
  'app.business.notFoundCta': 'Search instead',
  'app.business.errorTitle': 'We could not load this page',
  'app.business.errorBody': 'Check your connection and try again.',
  'app.business.openUntilT': 'Open until {time}',
  'app.business.open24': 'Open 24 hours',
  'app.business.closedToday': 'Closed today',
  'app.business.closedOpens': 'Closed · opens {day} {time}',
  'app.business.closedDays': 'Closed {days}',
  // Day names in an hours run ("Sat–Thu"); Bangla writes the name without "-বার".
  'app.business.runDay.sun': 'Sun',
  'app.business.runDay.mon': 'Mon',
  'app.business.runDay.tue': 'Tue',
  'app.business.runDay.wed': 'Wed',
  'app.business.runDay.thu': 'Thu',
  'app.business.runDay.fri': 'Fri',
  'app.business.runDay.sat': 'Sat',
  'app.business.reviewsCount': '{n, plural, one{# review} other{# reviews}}',
  'app.business.ratingLabel': 'rating',
  'app.business.servicesLabel': 'services',
  'app.business.serialsLeftOn': 'serials left {day}',
  'app.business.spotsLeftOn': 'spots left {day}',
  'app.business.reviewsPillN': 'Reviews {n}',
  'app.business.reviewsTitle': 'Reviews',
  'app.business.reviewsLabel': '{n, plural, one{review} other{reviews}}',
  'app.business.takesPhone': 'This business takes bookings by phone or WhatsApp.',
  'app.business.pausedNote': 'Online booking is paused for now. You can still call or message.',
  'app.business.free': 'Free',
  'app.business.onRequest': 'On request',
  'app.business.offerApplied': 'Offer applied',
  'app.business.offerOff': '{n}% off',
  'app.business.spotsRemaining': '{n} left',
  'app.business.hoursAndPlace': 'Hours & location',
  'app.business.openMap': 'Open in maps',
  'app.business.nagad': 'Nagad',
  'app.business.rocket': 'Rocket',
  'app.business.bank': 'Bank transfer',
  'app.business.tierFlexible': 'Flexible cancellation',
  'app.business.tierModerate': 'Moderate cancellation',
  'app.business.tierStrict': 'Strict cancellation',
  'app.business.ratingOutOf': '{r} out of 5',
  'app.business.verifiedBooking': 'Verified booking',
  'app.business.replyFrom': 'Reply from the business',
  'app.business.noReviews': 'No reviews yet.',
  'app.business.similar': 'Nearby places',
  'app.business.callA11y': 'Call this business',
  'app.business.noPhone': 'This business has not shared a phone number.',
  'app.business.noMap': 'No map location is available for this business.',
  'app.business.amenity.ac': 'AC',
  'app.business.amenity.lights': 'Floodlights',
  'app.business.reportTitle': 'Report this review',
  'app.business.reportFailed': 'We could not send the report. Try again.',
} as const satisfies Record<string, string>;

export const appBnBusiness = {
  'app.business.back': 'পেছনে',
  'app.business.shareA11y': 'এই ব্যবসা শেয়ার করুন',
  'app.business.saveA11y': 'এই ব্যবসা সেভ করুন',
  'app.business.unsaveA11y': 'সেভ করা থেকে সরান',
  'app.business.galleryA11y': '{name}-এর ছবি',
  'app.business.saved': 'সেভ হয়েছে',
  'app.business.unsaved': 'সেভ করা থেকে সরানো হয়েছে',
  'app.business.saveError': 'সেভ করা তালিকা আপডেট করা যায়নি। আবার চেষ্টা করুন।',
  'app.business.offlineAction': 'আপনি অফলাইনে আছেন। এটি করতে ইন্টারনেটে যুক্ত হন।',
  'app.business.notFoundTitle': 'এই ব্যবসাটি পাওয়া যায়নি',
  'app.business.notFoundBody': 'লিংকটি পুরনো হতে পারে, অথবা লিস্টিংটি আর নেই।',
  'app.business.notFoundCta': 'খুঁজে দেখুন',
  'app.business.errorTitle': 'পেজটি লোড করা যায়নি',
  'app.business.errorBody': 'ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.business.openUntilT': '{time} পর্যন্ত খোলা',
  'app.business.open24': '২৪ ঘণ্টা খোলা',
  'app.business.closedToday': 'আজ বন্ধ',
  'app.business.closedOpens': 'বন্ধ · {day} {time}-এ খুলবে',
  'app.business.closedDays': '{days} বন্ধ',
  'app.business.runDay.sun': 'রবি',
  'app.business.runDay.mon': 'সোম',
  'app.business.runDay.tue': 'মঙ্গল',
  'app.business.runDay.wed': 'বুধ',
  'app.business.runDay.thu': 'বৃহস্পতি',
  'app.business.runDay.fri': 'শুক্র',
  'app.business.runDay.sat': 'শনি',
  'app.business.reviewsCount': '{n}টি রিভিউ',
  'app.business.ratingLabel': 'রেটিং',
  'app.business.servicesLabel': 'সেবা',
  'app.business.serialsLeftOn': 'সিরিয়াল বাকি {day}',
  'app.business.spotsLeftOn': 'জায়গা বাকি {day}',
  'app.business.reviewsPillN': 'রিভিউ {n}',
  'app.business.reviewsTitle': 'রিভিউ',
  'app.business.reviewsLabel': 'রিভিউ',
  'app.business.takesPhone': 'এই ব্যবসা ফোন বা হোয়াটসঅ্যাপে বুকিং নেয়।',
  'app.business.pausedNote': 'অনলাইন বুকিং এখন স্থগিত। তবে কল বা মেসেজ করতে পারবেন।',
  'app.business.free': 'বিনামূল্যে',
  'app.business.onRequest': 'অনুরোধে',
  'app.business.offerApplied': 'অফার প্রযোজ্য',
  'app.business.offerOff': '{n}% ছাড়',
  'app.business.spotsRemaining': '{n}টি বাকি',
  'app.business.hoursAndPlace': 'সময় ও ঠিকানা',
  'app.business.openMap': 'ম্যাপে খুলুন',
  'app.business.nagad': 'নগদ',
  'app.business.rocket': 'রকেট',
  'app.business.bank': 'ব্যাংক ট্রান্সফার',
  'app.business.tierFlexible': 'নমনীয় বাতিল নীতি',
  'app.business.tierModerate': 'মাঝারি বাতিল নীতি',
  'app.business.tierStrict': 'কড়া বাতিল নীতি',
  'app.business.ratingOutOf': '৫-এর মধ্যে {r}',
  'app.business.verifiedBooking': 'যাচাইকৃত বুকিং',
  'app.business.replyFrom': 'ব্যবসার উত্তর',
  'app.business.noReviews': 'এখনো কোনো রিভিউ নেই।',
  'app.business.similar': 'কাছের জায়গা',
  'app.business.callA11y': 'এই ব্যবসাকে কল করুন',
  'app.business.noPhone': 'এই ব্যবসা কোনো ফোন নম্বর দেয়নি।',
  'app.business.noMap': 'এই ব্যবসার ম্যাপ লোকেশন পাওয়া যায়নি।',
  'app.business.amenity.ac': 'এসি',
  'app.business.amenity.lights': 'ফ্লাডলাইট',
  'app.business.reportTitle': 'রিভিউটি রিপোর্ট করুন',
  'app.business.reportFailed': 'রিপোর্ট পাঠানো যায়নি। আবার চেষ্টা করুন।',
} as const satisfies Record<string, string>;
